module.exports = __webpack_public_path__ + "static/media/home.8dde2c81.png";